var exports = {
  "az": "Box__uXH5i3",
  "m4": "Octicon__HJh7dv",
  "EY": "Text__75uXc0",
  "UE": "Text_1__HIcQ46",
  "lZ": "Banner__Wqcve7",
  "ZH": "BannerDescription__JoWLFg",
};

module.exports = exports;
